module.exports = {
    searchTitle:'KOL Search',
    search:'search',
    youTube: 'YouTube',
    tikTok: 'Tik Tok',
    instagram: 'Instagram',
    kolSearcePlacehold: 'Type channel title or keywords',
    Influence: 'Influencer',
    influencer:'Influencer',
    topicTags: 'Topic Tags',
    AudienceSS:'Audience',
    Followers:'Followers',
    Subcribers:'Subscribers',
    saf:'Save failed',
    edf:'Edit failed',
    haven:'have existed',
    Engagement:'Engagement Rate',
    viewNum:'Total Views',
    videosNum:'Total Videos',
    Videos:'Videos',
    _score:"Sort By Random",
    rusults:' results',
    Following:'Following',
    searchResult:'Input search text',
    Basicusage:'Input value',
    Area:'Area',
    Language:'Language',
    mostLang:'Language Rank',
    Age:'Age',
    imageCreatives:'Image Creatives',
    videoCreatives:'Video Creatives',
    Gender:'Gender',
    Category:'Category',
    viewSub:'Views/Subs',
    EngagementRate:'Engagement Rate',
    Est:'Est.Views',
    adnService:'ADN Service',
    Posts:'Posts',
    subscribersNum:'Sort By Subs',
    exposureNum:'Sort By Est.Views',
    channelCreateTime:'Sort By Collected Date',
    min:'min',
    max:'max',
    id:'ID',
    joinTime:'Joined on',
    Channel:'Channel Analysis',
    Audience:'Audience',
    confirm:'Confirm',
    noau:"You don't have authority to operate",
    SexAndAge:'Estimated Audience Age & Gender ',
    Countrys:'Estimated Audience Geography',
    sandian:'Active viewers distribution of time',
    Top:'Top 5 overlapped audience channels',
    Overlap:'Overlap rate',
    Related:'Related Channels',
    Hash:'Hash Tags',
    Original:'Original Sound',
    More:'View More ',
    Tag:'Channel Tags',
    Average:'Average Video Views',
    level:'Followers Rank',
    global:'global',
    tipwatchNum:'Latest 30 Videos',
    tipsInsvideo:'Average number of engagement rate for the last 10 posts',
    tipsvideo:'The engagement rate was calculated based one the interaction performance of the last 20 videos',
    sandianTip:'The percentage number of active audiences will be sorted by time,the time zone is the same as the channel.',
    echartstip:'The data is estimated by data algorithm according to the similar types of influencers in the same region. It may have some deviation from the actual data of the influencer To get the actual data please contact the influencer directly.',
    kols:'KOLS',
    KOL:'KOL',
    folders:'Folders',
    nox:'Nox Category',
    floderslosa:'KOL Collection Folders',
    folderdisc:'Folder Description',
    All:'All',
    op:'Operate',
    yunying:'Media Partner',
    kehu:'Advertiser',
    cd:'Created Date',
    Edit:'Edit',
    move:'Move',
    df:'Delete Folder',
    copy:'Copy',
    Optioned:'Optioned',
    clear:'Clear',
    delete:'Delete',
    searchkol:'Search KOL',
    sChannel:'Channel',
    sfn:'Search Folder Name',
    af:'Add Folder',
    kollist:'KOL List',
    kolfolder:'KOL Folders',
    fn:'Folder Name',
    Remarks:'Remarks',
    pian:'Please input folder name',
    lean:'Length should be 3 to 20',
    petfd:'Please enter the folder description',
    petfa:'Please enter the folder name',
    cnf:'Create New Folder',
    ef:'Edit Folder',
    aktc:'Add KOL to Collection',
    akfc:'Add KOL From Collection',
    sc:'Search Colletcion',
    cc:'Cancel Collection',
    cloolections:'Collection',
    lengthto100:'Length should be 0 to 100',
    pcofal:'Please choose one folder at least',
    collc:'Collection success',
    JO:'Only one can be choosen',
    overone:'have more than one item',
    khedcn:'kolId has exist.Duplication collection name',
    opf:'Operate fail',
    ccs:'Cancel collection success',
    ccf:'Cancel collection fail',
    loadings:"I'm loading... "
}



// WEBPACK FOOTER //
// ./src/i18n/modules/kolsearch/en.js